/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Shy_Cod_PokeInputs */

const en_mild_shy_cod_poke = /** @type {(inputs: Mild_Shy_Cod_PokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removed membership`)
};

const de_mild_shy_cod_poke = /** @type {(inputs: Mild_Shy_Cod_PokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer entfernt`)
};

/**
* | output |
* | --- |
* | "Removed membership" |
*
* @param {Mild_Shy_Cod_PokeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_shy_cod_poke = /** @type {((inputs?: Mild_Shy_Cod_PokeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Shy_Cod_PokeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_shy_cod_poke(inputs)
	return de_mild_shy_cod_poke(inputs)
});